import { createFileRoute } from '@tanstack/react-router';

import { WorkRequestsPage } from '@/features/me/talent-pages';

export const Route = createFileRoute('/_app/me/work/requests')({ component: WorkRequestsPage });
